import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';

// SERVICES
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  IAppIntegrationAccount,
  IGetApiResponse,
  IGetApiResponseMeta,
} from '../../../shared/interfaces';
import { AppIntegrationAccountApiService } from '../../../shared/services/api/app-integration/app-integration-account-api.service';

// INTERFACES

// CONSTANTS
import { EAppAccountType } from '../../../system-setting/constants';

@Component({
  selector: 'lum-app-integration-account-control',
  templateUrl: './app-integration-account-control.component.html',
  styleUrls: ['./app-integration-account-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppIntegrationAccountControlComponent),
      multi: true,
    },
  ],
})
export class AppIntegrationAccountControlComponent implements OnInit, OnDestroy {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();
  public appIntegrationAccounts :IAppIntegrationAccount[] = [];
  public displayValue :string;

  private onChange :any = () => {};
  private onTouched :any = () => {};

  selectedAccount :Partial<IAppIntegrationAccount>;
  paginateClientsPage :number = 1;
  params :Record<string, any> = {
    page: 1,
    sortField: 'label',
  };
  meta :IGetApiResponseMeta = {
    current_page: 1,
    from: 1,
    last_page: 0,
    path: '',
    per_page: 0,
    to: 0,
    total: 0,
  };
  isPaginating = false;

  @Input() appAccountType :string | string[] = EAppAccountType.ALL;

  @Output() onAppAccountSelect :EventEmitter<Partial<IAppIntegrationAccount>> =
    new EventEmitter();

  private onDestroy$ = new Subject();

  constructor(
    private appIntegrationAccountApiService :AppIntegrationAccountApiService,
    private changeDetectorRef :ChangeDetectorRef,
  ) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  writeValue(value :any) :void {
    if (!value || value === null) {
      return;
    }
    this.getById(value);
  }

  registerOnChange(fn :any) :void {
    this.onChange = fn;
  }

  registerOnTouched(fn :any) :void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled :boolean) :void {
    // You can implement this if you need to handle disabling the component
  }

  ngOnInit() :void {
    this.getRecords();
  }

  onSelectEvent(selectedAccount :IAppIntegrationAccount) {
    this.displayValue = selectedAccount.label;
    this.selectedAccount = selectedAccount;
    this.onAppAccountSelect.emit(this.selectedAccount);
    this.onChange(this.selectedAccount.id);
  }

  onChangeEvent(keyword :string) {
    this.onChange(null);
    this.params.searchQuery = keyword;
    this.params.page = 1;
    this.paginateClientsPage = 1;
    this.appIntegrationAccounts = [];
    this.getRecords();
  }

  getById(id :number) {
    this.appIntegrationAccountApiService
      .getById(id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (record :IAppIntegrationAccount) => {
          this.onSelectEvent(record);
          this.changeDetectorRef.detectChanges();
        },
        error: (e) => {},
      });
  }

  resetValues() {
    this.onChange(null);
  }

  getRecords() :void {
    if (
      this.appAccountType !== EAppAccountType.ALL &&
      this.appAccountType instanceof String
    ) {
      this.params.app = this.appAccountType;
    }
    this.resetValues();
    this._loading.next(true);
    this.appIntegrationAccountApiService
      .get(this.params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response :IGetApiResponse) => {
          if (response?.data) {
            const responseData = response.data.filter((row :any) =>
              Array.isArray(this.appAccountType)
                ? this.appAccountType.includes(row.app)
                : true,
            );

            this.appIntegrationAccounts =
              this.paginateClientsPage === 1
                ? responseData
                : [...(this.appIntegrationAccounts ?? []), ...responseData];

            this.meta = response.meta ?? this.meta;
          }
          this._loading.next(false);
          this.isPaginating = false;
          this.changeDetectorRef.detectChanges();
        },
        error: (e) => {
          this._loading.next(false);
        },
      });
  }

  onPaginateAppIntegrationaccounts() :void {
    if (this.meta.last_page > this.paginateClientsPage && !this.isPaginating) {
      this.isPaginating = true;
      this.paginateClientsPage += 1;
      this.params.page = this.paginateClientsPage.toString();
      this.getRecords();
    }
  }
}
